import {UserDto} from "@reside/reside-api-app";
import {http} from "./api";

export const AUTH_SIGN_IN_URL = "/auth/sign-in";

export const AuthService = {
  signIn: (data: {username: string; password: string}) =>
    http.post<{token: string; user: UserDto}>(AUTH_SIGN_IN_URL, data),
};
